import DefaultLayout from "../layouts/DefaultLayout";
import useTranslation from "../hooks/translations";
import {useUser} from "../contexts/UserProvider";
import InputField from "../components/InputField";
import {useMemo, useRef, useState} from "react";
import {Form, Nav} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import {useApi} from "../contexts/ApiProvider";
import UserService from "../services/UserService";
import {toast} from "react-toastify";

export default function AccountProfilePage() {
  const translations = useTranslation();
  const {user, setUser} = useUser();
  const api = useApi()
  const userService = useMemo(() => new UserService(api), [api]);

  const firstNameField = useRef();
  const lastNameField = useRef();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (event) => {
    event.preventDefault();

    const firstName = firstNameField.current.value;
    const lastName = lastNameField.current.value;

    const errors = {};
    if (!firstName && !lastName) {
      errors.firstName = translations.errorUpdateProfile;
      errors.lastName = translations.errorUpdateProfile;
    }
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }

    let payload = {}
    if (firstName && !lastName) {
      payload = {first_name: firstName}
    } else if (!firstName && lastName) {
      payload = {last_name: lastName}
    } else {
      payload = {first_name: firstName, last_name: lastName}
    }
    const response = await userService.updateProfile(payload)
    if (response.ok) {
      setUser(response.body)
      firstNameField.current.value = "";
      lastNameField.current.value = "";
      toast.success(translations.profileUpdateSuccess)
    }
  }

  return (
    <DefaultLayout header="CostCategory">
      <div className="container-xl px-4 mt-4">
        <nav className="nav nav-borders">
          <Nav.Link as={NavLink} to="/account-profile"
                    className="nav-link">
            {translations.account}</Nav.Link>
          <Nav.Link as={NavLink} to="/account-security"
                    className="nav-link">
            {translations.security}</Nav.Link>
        </nav>
        <hr className="mt-0 mb-4"/>
        <div className="row">
          <div className="col-xl-8">
            <div className="card mb-4">
              <div className="card-header">{translations.accountDetails}</div>
              <div className="card-body">
                <Form onSubmit={onSubmit}>
                  <div className="mb-3">
                    <label className="small mb-1"
                           htmlFor="inputUsername">{translations.email}</label>
                    <input className="form-control" id="inputEmail"
                           type="text"
                           disabled
                           value={`${user.email}`}/>
                  </div>
                  <div className="row gx-3 mb-3">
                    <div className="col-md-6">
                      <InputField
                        name="inputFirstName"
                        label={translations.firstName}
                        error={formErrors.firstName}
                        fieldRef={firstNameField}
                        placeholder={`${user.first_name}`}/>
                    </div>
                    <div className="col-md-6">
                      <InputField
                        name="inputLastName"
                        label={translations.lastName}
                        error={formErrors.lastName}
                        fieldRef={lastNameField}
                        placeholder={`${user.last_name}`}/>
                    </div>
                  </div>
                  <button className="btn btn-primary"
                          type="submit">{translations.save}
                  </button>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  )
}
